const COUNTRIES = {
  CA: 'Canada',
  US: 'USA',
}

export default COUNTRIES

export const DEFAULT_COUNTRY = 'CA'
